<template>
  <div class="resetpwd">
    <div class="login-overlay"></div>
    <div class="_box">
      <div class="_left">
        <img alt="" src="~@/assets/image/login-box-left.svg" srcset="" />
      </div>
      <div class="_right">
        <div class="_top">
          <img alt="" class="_l" src="~@/assets/image/logo.png" srcset="" />
          <div class="_brand">
            <div class="_name">维特沃斯</div>
            <div class="_r">ERP 后台管理系统</div>
          </div>
        </div>
        <div class="_title">
          修改密码<span>（首次登录必须先修改密码）</span>
        </div>
        <a-form-model
          ref="ruleForm"
          :model="form"
          :rules="rules"
          class="resetpwd-form"
        >
          <a-form-model-item ref="username" prop="username">
            <a-input
              v-model="form.username"
              :disabled="true"
              allow-clear
              placeholder="用户名/手机号"
              @blur="
                () => {
                  $refs.username.onFieldBlur()
                }
              "
            >
              <a-icon slot="prefix" type="user" />
            </a-input>
          </a-form-model-item>
          <a-form-model-item ref="oldpassword" prop="oldpassword">
            <a-input
              v-model="form.oldpassword"
              allow-clear
              placeholder="输入旧密码"
              type="password"
              @blur="
                () => {
                  $refs.oldpassword.onFieldBlur()
                }
              "
            >
              <a-icon slot="prefix" type="lock" />
            </a-input>
          </a-form-model-item>
          <a-form-model-item ref="password" prop="password">
            <a-popover
              :visible="popoverVisible"
              overlayClassName="login-form-popover"
              placement="rightTop"
              trigger="click"
            >
              <template slot="content">
                <div>
                  <a-icon
                    :style="{ color: hasSpeace ? '#0B7EF8' : '#52c41a' }"
                    :type="hasSpeace ? 'exclamation-circle' : 'check-circle'"
                    theme="filled"
                  />
                  <span>不能包含空格</span>
                </div>
                <div>
                  <a-icon
                    :style="{ color: trueLength ? '#0B7EF8' : '#52c41a' }"
                    :type="trueLength ? 'exclamation-circle' : 'check-circle'"
                    theme="filled"
                  />
                  <span>长度为6-11个字符</span>
                </div>
                <div>
                  <a-icon
                    :style="{ color: hasSpecial ? '#0B7EF8' : '#52c41a' }"
                    :type="hasSpecial ? 'exclamation-circle' : 'check-circle'"
                    theme="filled"
                  />
                  <span>由数字和字母组成，<br />不能包含特殊字符</span>
                </div>
              </template>
              <a-input
                v-model="form.password"
                allow-clear
                placeholder="输入新密码"
                type="password"
                @blur="
                  () => {
                    popoverVisible = false
                    $refs.password.onFieldBlur()
                  }
                "
                @change="passwordChange"
                @focus="
                  () => {
                    popoverVisible = true
                  }
                "
              >
                <a-icon slot="prefix" type="lock" />
              </a-input>
            </a-popover>
          </a-form-model-item>
          <a-form-model-item ref="repassword" prop="repassword">
            <a-input
              v-model="form.repassword"
              allow-clear
              placeholder="再次输入"
              type="password"
              @blur="
                () => {
                  $refs.repassword.onFieldBlur()
                }
              "
            >
              <a-icon slot="prefix" type="lock" />
            </a-input>
          </a-form-model-item>
          <a-form-model-item class="resetpwdwrapper">
            <a-button
              :loading="loading"
              class="resetpwd-btn"
              type="primary"
              @click="onSubmit"
            >
              <span v-if="!loading">提 交</span>
              <span v-else>提 交 中...</span>
            </a-button>
          </a-form-model-item>
        </a-form-model>
      </div>
    </div>
  </div>
</template>
<script>
import md5 from "js-md5" // 使用md5加密密码
import { updatepwd } from "@/api/user"
import { defaultPassWord } from "@/config"

export default {
  data() {
    // 验证确认密码
    let validateRepasswword = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次确认密码"))
      } else if (value !== this.form.password) {
        callback(new Error("两次密码不一致"))
      } else {
        callback()
      }
    }
    // 验证新密码输入
    let validatePasswword = (rule, value, callback) => {
      // 新密码正则验证
      let special = new RegExp(/[A-Za-z].*[0-9]|[0-9].*[A-Za-z]/)
      if (value.trim() === "") {
        this.popoverVisible = true
        callback(new Error("请输入密码"))
      } else if (value.includes(" ")) {
        this.popoverVisible = true
        callback(new Error("不能包含空格"))
      } else if (!special.test(value)) {
        this.popoverVisible = true
        callback(new Error("由数字和字母组成，不能包含特殊字符"))
      } else if (value.length < 6 || value.length > 11) {
        this.popoverVisible = true
        callback(new Error("长度为6-11个字符"))
      } else {
        this.popoverVisible = false
        callback()
      }
    }
    return {
      cookiePass: "",
      account: undefined,
      form: {
        username: "",
        password: "",
        oldpassword: defaultPassWord,
        repassword: ""
      },
      hasSpeace: true,
      trueLength: true,
      hasSpecial: true,
      loading: false, // 登录等待状态
      popoverVisible: false,
      rules: {
        username: [
          {
            required: true,
            message: "请输入账号/用户名",
            trigger: "blur"
          }
        ],
        oldpassword: [
          {
            required: true,
            message: "请输入旧密码",
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            validator: validatePasswword,
            trigger: "blur"
          }
        ],
        repassword: [
          {
            required: true,
            validator: validateRepasswword,
            trigger: "blur"
          }
        ]
      }
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        this.account = route.query && route.query.account
        this.form.username = this.account
      },
      immediate: true
    }
  },
  methods: {
    // 密码框修改
    passwordChange(e) {
      let { value } = e.target
      if (value.includes(" ") || value.trim() === "") {
        this.hasSpeace = true
      } else {
        this.hasSpeace = false
      }
      // 新密码正则验证
      let special = new RegExp(/[A-Za-z].*[0-9]|[0-9].*[A-Za-z]/)
      if (special.test(value)) {
        this.hasSpecial = false
      } else {
        this.hasSpecial = true
      }

      if (value.length < 6 || value.length > 10) {
        this.trueLength = true
      } else {
        this.trueLength = false
      }
    },
    // 登录
    onSubmit() {
      const that = this
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          that.loading = true
          updatepwd({
            password: md5(md5(this.form.password) + "wtws"),
            oldPassWord: md5(md5(this.form.oldpassword) + "wtws")
          })
            .then(res => {
              if (res.code === 14) {
                this.$message.success(res.message || "修改成功，请重新登录")
                this.$store.commit("SET_FIRST", false)
                // 清除登录态后再跳转，避免仍持有 token 时被路由拦回首页
                this.$store.commit("SET_TOKEN", "")
                this.$store.dispatch("LogOut", false)
              }
              that.loading = false
            })
            .catch(() => {
              that.loading = false
            })
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.resetpwd {
  position: relative;
  min-width: 1100px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background: url("~@/assets/image/back-ground1.png") no-repeat 50%;
  background-size: cover;
  box-sizing: border-box;
  overflow: hidden;

  .login-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(
      135deg,
      rgba(11, 46, 94, 0.35) 0%,
      rgba(24, 144, 255, 0.18) 45%,
      rgba(8, 28, 58, 0.4) 100%
    );
    pointer-events: none;
  }

  ._box {
    position: relative;
    z-index: 1;
    width: 1022px;
    min-height: 560px;
    background: rgba(255, 255, 255, 0.96);
    border-radius: 16px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    box-shadow: 0 20px 60px rgba(8, 28, 58, 0.28),
      0 2px 8px rgba(8, 28, 58, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.6);
    backdrop-filter: blur(8px);

    ._left {
      img {
        display: block;
        width: 406px;
        height: 406px;
        margin-left: 56px;
        margin-right: 72px;
      }
    }

    ._right {
      flex: 1;
      padding-right: 48px;

      ._top {
        display: flex;
        align-items: center;
        margin-bottom: 28px;

        ._l {
          margin-right: 20px;
          display: block;
          width: 72px;
          height: 72px;
          border-radius: 16px;
          object-fit: contain;
          box-shadow: 0 6px 16px rgba(24, 144, 255, 0.18);
        }

        ._brand {
          ._name {
            font-size: 22px;
            font-weight: 600;
            color: #0b1f3a;
            line-height: 1.2;
            letter-spacing: 1px;
          }

          ._r {
            margin-top: 6px;
            font-size: 14px;
            font-weight: 400;
            color: #1890ff;
          }
        }
      }

      ._title {
        font-size: 18px;
        font-weight: 600;
        text-align: left;
        color: rgba(0, 0, 0, 0.85);
        margin-bottom: 20px;

        span {
          color: rgba(0, 0, 0, 0.45);
          font-size: 13px;
          font-weight: 400;
          margin-left: 6px;
        }
      }

      .resetpwd-form {
        width: 360px;

        ::v-deep .ant-input-affix-wrapper {
          padding: 0;
          border: none;
          transition: all 0.2s;

          .ant-input {
            height: 40px;
            border-radius: 8px;
            border: 1px solid #e8ecf1;
            background: #fff;
            transition: all 0.2s;

            &:hover,
            &:focus {
              border-color: #1890ff;
              box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.12);
            }
          }

          &.ant-input-affix-wrapper-focused .ant-input {
            border-color: #1890ff;
            box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.12);
          }
        }

        ::v-deep .ant-input-prefix {
          color: #8c9aab;
        }

        ::v-deep .ant-input-affix-wrapper .ant-input:not(:first-child) {
          padding-left: 36px;
        }

        ::v-deep .ant-input-affix-wrapper .ant-input:not(:last-child) {
          padding-right: 36px;
        }

        ::v-deep
          .ant-input-affix-wrapper.ant-input-affix-wrapper-input-with-clear-btn
          .ant-input:not(:last-child) {
          padding-right: 49px;
        }

        ::v-deep .ant-form-item {
          .resetpwd-btn {
            width: 100%;
            height: 46px;
            background: linear-gradient(135deg, #4dabff 0%, #1677ff 100%);
            border-radius: 10px;
            margin: 0;
            border: none;
            line-height: 46px;
            font-size: 16px;
            font-weight: 600;
            letter-spacing: 4px;
            box-shadow: 0 8px 20px rgba(22, 119, 255, 0.35);
          }

          &.resetpwdwrapper {
            .ant-form-item-control-wrapper {
              width: 100%;
            }
          }
        }
      }
    }
  }
}
</style>
